import { getWebsiteBuilderAdminUrl } from "./addHttpToUrl";

export type CmpExternalLinkDestination = "websiteBuilderAdmin";

export const getCmpExternalRouteHref = ({
  destination,
  routePath,
  websiteUrl,
}: {
  destination?: CmpExternalLinkDestination;
  routePath: string;
  websiteUrl: string | null | undefined;
}): string => {
  if (destination === "websiteBuilderAdmin") {
    return getWebsiteBuilderAdminUrl(websiteUrl);
  }

  return routePath;
};
